// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"_1Knmec","iconWrapperDefault":"_1yNnLW","iconDefault":"_3r_SKn"};